/**
 * Portal Manta · extrairKpisDoFormatoManta
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { extKm } from '../../globals.js';

function extrairKpisDoFormatoManta(obj){
  const out = { _formato:'manta-completo', _origem:[] };
  // Identificação
  if (obj.projeto_nome) out.nome = obj.projeto_nome;
  if (obj.projeto_id)   out._projetoId = obj.projeto_id;

  // Sistema rodoviário · extensão total
  const combinado = obj.combinado || {};
  const sr = combinado.sistema_rodoviario || [];
  let extTotal = 0;
  let rodoviasComExt = 0;
  for (const r of sr){
    if (typeof r.ext_km === 'number'){ extTotal += r.ext_km; rodoviasComExt++; }
  }
  if (extTotal > 0){
    out.extKm = Math.round(extTotal * 10) / 10;
    out._origem.push(`extKm=${out.extKm} de ${rodoviasComExt}/${sr.length} rodovias do PER`);
  } else if (combinado.extensao_total_km && combinado.extensao_total_km > 0){
    out.extKm = combinado.extensao_total_km;
    out._origem.push('extKm de combinado.extensao_total_km');
  }

  // Obras (do PER)
  const obras = combinado.obras || {};
  const sumKm = (arr) => Array.isArray(arr) ? arr.reduce((s,x)=>s + (parseFloat(x.ext_km||x.km||x.extensao_km||0)||0), 0) : 0;
  const sumQt = (arr) => Array.isArray(arr) ? arr.length : 0;

  const dupKm = sumKm(obras.duplicacoes) + sumKm(obras.adequacao_duplicacao) + sumKm(obras.contornos);
  if (dupKm > 0){ out.dupKm = Math.round(dupKm*10)/10; out._origem.push(`dupKm=${out.dupKm} de obras.duplicacoes+adequacao+contornos`); }

  const margKm = sumKm(obras.vias_marginais);
  if (margKm > 0){ out.margKm = Math.round(margKm*10)/10; out._origem.push(`margKm=${out.margKm} de obras.vias_marginais`); }

  const fxKm = sumKm(obras.faixas_adicionais);
  if (fxKm > 0){ out.fxKm = Math.round(fxKm*10)/10; out._origem.push(`fxKm=${out.fxKm} de obras.faixas_adicionais`); }

  const ciclKm = sumKm(obras.ciclovias);
  if (ciclKm > 0){ out.ciclKm = Math.round(ciclKm*10)/10; out._origem.push(`ciclKm=${out.ciclKm} de obras.ciclovias`); }

  const oaeQt = sumQt(obras.oaes);
  if (oaeQt > 0){ out.oaeQt = oaeQt; out._origem.push(`oaeQt=${oaeQt} de obras.oaes (count)`); }

  const passQt = sumQt(obras.passarelas);
  if (passQt > 0){ out.passQt = passQt; out._origem.push(`passQt=${passQt} de obras.passarelas (count)`); }

  // Interseções pode ser dict de tipos
  if (obras.intersecoes && typeof obras.intersecoes === 'object'){
    let interTotal = 0;
    for (const k of Object.keys(obras.intersecoes)){
      const v = obras.intersecoes[k];
      if (Array.isArray(v)) interTotal += v.length;
    }
    if (interTotal > 0){ out.interQt = interTotal; out._origem.push(`interQt=${interTotal} (soma de tipos em obras.intersecoes)`); }
  }

  // CAPEX (do MEF)
  const mef = obj.mef_combinado || {};
  if (mef.capex_consolidado?.total){
    out._capexTotal = mef.capex_consolidado.total;
    out._origem.push(`CAPEX consolidado=R$ ${(mef.capex_consolidado.total/1e9).toFixed(2)} bi (mef_combinado.capex_consolidado.total)`);
  }
  if (mef.opex_consolidado?.total){
    out._opexTotal = mef.opex_consolidado.total;
    out._origem.push(`OPEX consolidado=R$ ${(mef.opex_consolidado.total/1e9).toFixed(2)} bi`);
  }

  // Localização — tentar extrair UF de rodovias (formato BR-XXX/PR)
  const ufs = new Set();
  for (const r of sr){
    if (r.uf) ufs.add(r.uf);
    else if (r.rodovia){
      const m = r.rodovia.match(/\/([A-Z]{2})$/);
      if (m) ufs.add(m[1]);
    }
  }
  if (ufs.size === 1){
    out.uf = [...ufs][0];
    out._origem.push(`uf=${out.uf} (única detectada nas rodovias)`);
  } else if (ufs.size > 1){
    out.uf = [...ufs][0];
    out._origem.push(`uf=${out.uf} (predominante · também encontradas: ${[...ufs].slice(1).join(', ')})`);
  }

  return out;
}

export { extrairKpisDoFormatoManta };
export default extrairKpisDoFormatoManta;
